import React, { useCallback, useEffect, useRef, useState } from 'react';
import HighchartsTimeline from './HighchartsTimeline';
import HistoryPage, { HistoryPageProps } from './HistoryPage';
import { downloadFile, useEffectOnce } from '../../globalUtils/globalHooks';
import {
  useAppDispatch,
  useAppSelector,
} from '../../rmsReduxStore/rmsReduxHooks';
import {
  configureNotificationTypes,
  exportNotificationHistoryData,
  fetchNotificationHistoryTimelineData,
  getConfigureNotificationReducer,
} from '../../rmsReduxStore/reduxExports';
import { cloneDeep } from 'lodash';
import './HistorySidePopoverPage.css'
import { Id, toast } from 'react-toastify';
import IconDatePicker from '../../globalUtils/IconDatePicker/IconDatePicker';
import { Menu, MenuItem } from '@mui/material';
import { AxiosResponse } from 'axios';
import { configureNotificationHistoryInitialFilterValues } from '../../rmsReduxStore/filtersRedux/filterReducer';


interface HistorySidePopOverProps extends HistoryPageProps {
  notificationId?: string;
  exportAnchor: [HTMLElement | null, React.Dispatch<React.SetStateAction<HTMLElement | null>>];
}

export interface TimeLineDataPoint {
  y: number;
  name: number;
  x: number;
  color?: string;
  label?: string;
}

const HistorySidePopoverPage = function HistorySidePopoverPage(
  props: HistorySidePopOverProps
) {
  const {
    tableRows,
    totalCount,
    listLayoutCallBack,
    gridColumns,
    showLoader,
    pageNumber,
    tablePageSize,
    sortField,
    sortOrder,
    totalCountText,
    notificationId,
    exportAnchor,
  } = props;
  const dispatch = useAppDispatch();
  const { configureNotificationHistoryTimeline,configureNotificationHistoryListTableProps } = useAppSelector(
    getConfigureNotificationReducer
  );
  const configureNotificationHistoryListTablePropsRef = useRef(configureNotificationHistoryListTableProps)
  const [timeLineDataPoints, setTimeLineDataPoints] = useState<
    TimeLineDataPoint[]
  >([]);
  const [timeLineFilter, setTimeLineFilter] = useState<Filters[]>([{ key: 'fireTime', values: ['one_week'] }])
  const [exportAnchorEl, setExportAnchorEl] = exportAnchor;
  const [exportingFile,setExportingFile] = useState(false);

  useEffectOnce(() => {
    graphCallBack();
  });

  useEffect(() => {
    calculateDataPointsFortimeLine();
  }, [configureNotificationHistoryTimeline]);

  const graphCallBack = useCallback((filters?) => {
    dispatch(
      fetchNotificationHistoryTimelineData({
        notificationId: notificationId,
        filters: filters ? filters : timeLineFilter,
      })
    );
  }, [timeLineFilter]);

  const tableLayoutCallBack = useCallback((pageNumber: number, pageSize: number, view: string, field: string, order: string) => {
    listLayoutCallBack?.(pageNumber, pageSize, view, field, order, timeLineFilter)
  }, [timeLineFilter, listLayoutCallBack])

  const calculateDataPointsFortimeLine = useCallback(() => {
    if (configureNotificationHistoryTimeline) {
      const dataPoints = configureNotificationHistoryTimeline?.response?.map(
        (singleData) => {
          return {
            x: new Date(singleData?.time),
            y: 0,
            name: singleData?.value,
          };
        }
      );

      setTimeLineDataPoints([
        {
          x: new Date(configureNotificationHistoryTimeline?.startDateTime),
          y: 0,
          name: 0,
        },
        ...dataPoints,
        {
          x: new Date(configureNotificationHistoryTimeline?.endDateTime),
          y: 0,
          name: 0,
        },
      ]);
    }
  }, [configureNotificationHistoryTimeline]);

  const filterData = [
    {
      filterText: 'Today',
      filterValue: 'one_day',
      filterTextClassName: '',
      handleClick: () => {
        handleFilterChange('one_day')
      },
    },
    {
      filterText: 'Last 7 days',
      filterValue: 'one_week',
      filterTextClassName: '',
      handleClick: () => {
        handleFilterChange('one_week')
      },
    },
    {
      filterText: 'Last 30 days',
      filterValue: 'one_month',
      filterTextClassName: '',
      handleClick: () => {
        handleFilterChange('one_month')
      },
    },
    {
      filterText: '',
      filterValue: 'custom',
      filterTextClassName: '',
    },
  ];

  const onDateChange = useCallback((dates) => {
    const [start, end] = dates;
    if (start && end) {
      const differenceInMilliseconds = end.getTime() - start.getTime();
      const differenceInDays = differenceInMilliseconds / (1000 * 60 * 60 * 24);
      if (differenceInDays > 30) {
        toast.error('Date range exceeded more than 30 days.');
        return
      }
    }
    if (start) {
      handleFilterChange('custom', start, end)
    } else {
      handleFilterChange('one_week')
    }
  }, [])

  // const day =60 * 60 * 24 * 1000;

  const handleFilterChange = useCallback((val, start?, end?) => {
    let valuesToSet = [val]
    setTimeLineFilter((prevState) => {
      const previousFilters = cloneDeep(prevState)
      const filterToUpdate = previousFilters?.find((filter) => filter?.key === 'fireTime')
      if (filterToUpdate) {
        filterToUpdate.values = valuesToSet
        if (start) {
          const endDate = end;
          if (endDate)
            endDate.setDate(endDate.getDate())
          valuesToSet = [val, start, endDate]
          filterToUpdate.values = valuesToSet
        }
        if (val === 'custom' && !end) {
          // handleFilterChange('one_day')
          return previousFilters
        }
        // if(val === 'custom' && start && !end){

        // }
        if (val === 'custom' && (start.getTime() === end.getTime())) {
          // handleFilterChange('one_day')
          // return previousFilters
          const newEndDate = new Date(end);
          newEndDate.setDate(newEndDate.getDate())
          valuesToSet = [val, start, newEndDate]
          filterToUpdate.values = valuesToSet
        }
        const updatedFilter = cloneDeep(previousFilters);
        if (!(val === 'one_day' || val === 'one_week' || val === 'one_month')) {
          updatedFilter?.forEach((filter) => {
            if (filter?.key === 'fireTime') {
              const newEndDate = cloneDeep(end);
              newEndDate.setDate(newEndDate.getDate() + 1)
              filter.values = [filterToUpdate?.values?.[0], filterToUpdate?.values?.[1], newEndDate]
            }
          })
        }
        graphCallBack((val === 'one_day' || val === 'one_week' || val === 'one_month') ? previousFilters : updatedFilter)
        listLayoutCallBack?.(pageNumber, tablePageSize, 'list', sortField, sortOrder, previousFilters)
        return previousFilters
      }
      return prevState
    })
  }, [])

  const notificationTimeLineCleanUpStates = useCallback(() => {
    const action = {
      type: configureNotificationTypes.CLEAR_CONFIGURE_NOTIFICATION_HISTORY_TIMELINE,
    }
    dispatch(action);
  }, [])

  useEffect(() => {
    window.addEventListener('beforeunload', notificationTimeLineCleanUpStates);
    return (): void => {
      notificationTimeLineCleanUpStates()
      window.removeEventListener('beforeunload', notificationTimeLineCleanUpStates);
    }
  }, [])

  const getEndDateForIcon = useCallback(() => {
    const endDate = timeLineFilter?.find((filter) => filter?.key === 'fireTime')?.values?.[2] ? new Date(timeLineFilter?.find((filter) => filter?.key === 'fireTime')?.values?.[2] ?? '') : null;
    if (endDate) {
      const newEndDate = new Date(endDate);
      newEndDate.setDate(newEndDate.getDate());
      return newEndDate
    }
  }, [timeLineFilter])


        const handleClose = (): void => {
    setExportAnchorEl(null);
  };


  const fileDownloadSuccessToast = useCallback((): Id => {
      setExportingFile(false);
      return toast.success('Notification logs downloaded.');
    }, []);
  
    const fileDownloadFailureToast = useCallback((): Id => {
      setExportingFile(false);
      return toast.warn('Something went wrong. Please export again.');
    }, []);


    const onExportBtnClick = useCallback(async (fileType: 'csv' | 'xlsx'): Promise<void> => {
      if (exportingFile) {
        // If already exporting, prevent another export
        return;
      }
      try {
        const response: AxiosResponse = await dispatch(exportNotificationHistoryData({
          fileType,
          notificationId:notificationId,
          sortBy:configureNotificationHistoryListTablePropsRef?.current?.sortBy,
          order:configureNotificationHistoryListTablePropsRef?.current?.order,
          filters: configureNotificationHistoryInitialFilterValues
        }));
  
        if (response?.status === 202 || response?.status === 200) {
          downloadFile({ url: response?.data?.url });
          fileDownloadSuccessToast()
        } else {
          fileDownloadFailureToast();
          setExportAnchorEl(null);
        }
      } finally {
        // Ensure that exporting status is updated even if there's an error
        setExportingFile(false);
        setExportAnchorEl(null);
  
      }
    }, [exportingFile, fileDownloadSuccessToast, fileDownloadFailureToast,configureNotificationHistoryListTablePropsRef?.current])

  return (
    <div className='notification__history__popover'>
      <div className='timeline__quick__filter'>
        {filterData.map((filter, index) => {
          return (
            <div
              onClick={filter.handleClick}
              className='timeline__quick__filter__item'
              key={index}

            >
              <>
                {filter?.filterValue === 'custom' ?
                  <IconDatePicker
                    startDate={timeLineFilter?.find((filter) => filter?.key === 'fireTime')?.values?.[1] ? new Date(timeLineFilter?.find((filter) => filter?.key === 'fireTime')?.values?.[1] ?? '') : null}
                    // endDate={timeLineFilter?.find((filter) => filter?.key === 'fireTime')?.values?.[2] ? new Date(timeLineFilter?.find((filter) => filter?.key === 'fireTime')?.values?.[2] ?? '') : null}
                    endDate={getEndDateForIcon()}
                    onChange={onDateChange}
                    selectsRange={true}
                    renderToBody={true}
                    popperPlacement='bottom-start'
                  /> :
                  <div
                    className={`${filter?.filterTextClassName}`}
                    style={{
                      fontWeight: timeLineFilter?.find((filter) => filter?.key === 'fireTime')?.values?.[0] === filter.filterValue ? 700 : 400,
                      cursor: 'pointer',
                    }}
                  >
                    {filter.filterText}
                  </div>
                }
                {index < filterData.length - 1 && <div>|</div>}
              </>
            </div>
          );
        })}
      </div>
      <HighchartsTimeline timeLineDataPoints={timeLineDataPoints} />
      <div style={{ height: 'calc(100dvh - 326px)', display: 'block' }}>
        <HistoryPage
          gridColumns={gridColumns}
          tableRows={tableRows}
          totalCount={totalCount}
          listLayoutCallBack={tableLayoutCallBack}
          showLoader={showLoader}
          totalCountText={totalCountText}
          pageNumber={pageNumber}
          tablePageSize={tablePageSize}
          sortField={sortField}
          sortOrder={sortOrder}
          leftPinnedColumns={['fireTime']}
        />
        <Menu
          id="export-option-dropdown"
          anchorEl={exportAnchorEl}
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
          keepMounted
          transformOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
          className='export__option__dropdown'
          sx={{ top: '30px' }}
          open={Boolean(exportAnchorEl)}
          onClose={handleClose}
        >
          <MenuItem>
            <div className='export__btn-option' onClick={(e) => { e?.stopPropagation(); onExportBtnClick('csv') }}>
              To CSV
            </div>
          </MenuItem>
          <MenuItem>

            <div className='export__btn-option' onClick={(e) => {
              e?.stopPropagation();
              onExportBtnClick('xlsx')
            }}>
              To Excel
            </div>
          </MenuItem>
        </Menu>
      </div>
    </div>
  );
};

export default HistorySidePopoverPage;
